<form
  [formGroup]="otpForm"
  #form="ngForm"
  class="small:pb-0 relative flex h-full w-full flex-col justify-center pb-[50px]"
>
  <div class="mb-8">
    <ion-button class="go-back-button inline-flex items-center" (click)="goBack()">
      <dojo-icon [icon]="'arrow-left'" />
      <span class="ml-1">Go back</span>
    </ion-button>
  </div>
  <h2 class="text-display-md mb-2 font-medium text-neutral-950">Verify email</h2>
  <div class="small:mb-8 text-secondary mb-6 text-sm font-normal">Code has been sent to {{ maskEmail(email()) }}</div>

  <div class="relative mb-5 md:mb-6">
    <dojo-ote-input [formCtrl]="otpForm.controls.code" data-test="sign-in-otp-code" />

    @if (otpForm.controls.code.hasError('required') && otpForm.controls.code.touched) {
      <mat-error class="absolute mt-1 text-sm before:!hidden">
        {{ otpErrorMessages['required'] }}
      </mat-error>
    }

    @if (error()) {
      <mat-error class="absolute mt-1 text-sm before:!hidden">
        {{ error() }}
      </mat-error>
    }
  </div>

  <div class="small:flex-no-wrap flex flex-wrap gap-2 text-sm font-normal">
    <span class="text-secondary">Didn't receive the OTP code?</span>
    @if (otpResendTimer() > 0) {
      <span class="text-secondary font-medium"
        >Resend code in <span class="inline-flex w-[32px]">{{ otpResendTimer() }}s</span></span
      >
    } @else {
      <a class="flex items-center gap-1 font-medium text-sky-600 hover:text-sky-800" (click)="sendOTPCode()">
        <span>Resend code</span>
        <dojo-icon [icon]="'arrow-rotate-left'"></dojo-icon>
      </a>
    }
  </div>
  <div class="small:static small:inline-block absolute bottom-0 left-0 right-0 mt-8">
    <dojo-button
      class="small:inline-flex"
      submitButton
      [confirmFn]="otpConfirmFn"
      [disabled]="isVerifying()"
      data-test="login-button"
    >
      Verify
    </dojo-button>
  </div>
</form>
